import { dataAdDeliveryCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAdDeliveryCircleSolid = /*#__PURE__*/createIcon(dataAdDeliveryCircleSolid)
export default IconAdDeliveryCircleSolid
